import { Button } from '@chakra-ui/react'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'

import {
  FormSection,
  FormSectionBody,
  FormSectionDescription,
  FormSectionHeader,
  FormSectionTitle,
} from '../../components/FormSection'
import { MainContent } from '../../components/MainContent'
import { Save } from '../../icons'
import { ExtraInsuranceSme } from '../ExtraInsuranceSme'
import { FormButtons } from '../FormButtons'
import { Discounts } from '../discounts/Discounts'

interface Step2FormProps {
  onSubmit: Function
}

export interface Step2FormValues {
  flood: boolean
  floodFrequency: string
}

export const Step2Form = ({ onSubmit }: Step2FormProps) => {
  const methods = useForm<Step2FormValues>({
    defaultValues: {},
  })
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods

  const onSubmitForm = (values: Step2FormValues) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        onSubmit(values)
        resolve(true)
      }, 500)
    })
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <MainContent>
          <FormSection>
            <FormSectionHeader>
              <FormSectionTitle>Připojištění</FormSectionTitle>

              <FormSectionDescription>
                Vyberte limity zvoleného připojišťění.
              </FormSectionDescription>
            </FormSectionHeader>

            <FormSectionBody>
              <ExtraInsuranceSme />
            </FormSectionBody>
          </FormSection>

          <FormSection>
            <FormSectionHeader>
              <FormSectionTitle>Slevy pojištění</FormSectionTitle>

              <FormSectionDescription>
                Nastavte slevy pojistníka a jednotlivých pojišťoven.
              </FormSectionDescription>
            </FormSectionHeader>

            <FormSectionBody>
              <Discounts onDiscountsLoaded={() => {}} />
            </FormSectionBody>
          </FormSection>

          <FormButtons
            rightButtons={
              <>
                <Button variant="outline" isDisabled={isSubmitting} type="button">
                  Uložit
                </Button>
                <Button
                  colorScheme="primary"
                  isLoading={isSubmitting}
                  isDisabled={isSubmitting}
                  loadingText="Počítám nabídky..."
                  type="submit"
                >
                  <Save />
                  Uložit a spočítat nabídky
                </Button>
              </>
            }
          />
        </MainContent>
      </form>
    </FormProvider>
  )
}
